// extracted by mini-css-extract-plugin
module.exports = {"pt-active-sign-notes":"pt-active-sign-notes-575502284d4941a6b8dd561f5dda4170"};